export default __webpack_public_path__ + "static/media/work.deb465d9.png";